import { Component, OnInit } from '@angular/core';
import { DOData, NJDocData } from '../DOData';
import { DocDefPrimLibService } from '../../doc-def-prim-lib.service';
import { GridInternalAgGridComponent } from './grid-internal-ag-grid.component';
@Component({
    selector: 'cylib-grid-internal-ag-grid-cl',
    templateUrl: './grid-internal-ag-grid-cl.component.html',
    styleUrls: ['./grid-internal-ag-grid-cl.component.css']
})
export class GridInternalAgGridClComponent extends GridInternalAgGridComponent implements OnInit {

    constructor(public data: DocDefPrimLibService) {
        super(data);
        this.rowModelType = "clientSide";
    }

    ngOnInit() {
        super.ngOnInit();
        this.rowData = this.getRowData();
    }
    getRowData() {
        var rowsThisPage = [];
        for (var rowIndex = 0; rowIndex < this.getRows.length; rowIndex++) {
            var record = {};
            //let docDataRowID = _this.getRows[rowIndex];
            let docDataRowID = this.getRows[rowIndex];
            //Below For Loop Optimized For Improving Performance
            for (const template of this.lstChildDocDefTemplate) {
                const data = this.lstDocData.find(d =>
                    d.docDefDataRowID === docDataRowID &&
                    d.docDefTemplateID === template.docDefTemplateID
                );

                record["T" + template.docDefTemplateID.toString()] = data ? data.dataValue : "";
                record["id"] = docDataRowID == undefined ? null : docDataRowID.toString();
            }

            rowsThisPage.push(record);
        }
        return rowsThisPage;
    }
    public gridOptions = {
        onFirstDataRendered: this.headerHeightSetter,
        onColumnResized: this.headerHeightSetter,
        defaultColDef: {
            sortable: true,
            filter: true,
            resizable: true,
            headerComponentParams: {
                template:
                    '<div class="ag-cell-label-container" role="presentation">' +
                    '  <span ref="eMenu" class="ag-header-icon ag-header-cell-menu-button"></span>' +
                    '  <div ref="eLabel" class="ng-deep ag-header-cell-label ag-header-cell-text" role="presentation">' +
                    '    <span ref="eSortOrder" class="ag-header-icon ag-sort-order"></span>' +
                    '    <span ref="eSortAsc" class="ag-header-icon ag-sort-ascending-icon"></span>' +
                    '    <span ref="eSortDesc" class="ag-header-icon ag-sort-descending-icon"></span>' +
                    '    <span ref="eSortNone" class="ag-header-icon ag-sort-none-icon"></span>' +
                    '    <span ref="eText" class="ag-header-cell-text" role="columnheader" style="white-space: normal !important;"></span>' +
                    '    <span ref="eFilter" class="ag-header-icon ag-filter-icon"></span>' +
                    '  </div>' +
                    '</div>',
            },
            pdfExportOptions: {}
        },
        //pagination
        pagination: false,
        paginationPageSize: 10,
        // Setting Last Row Index
        cacheBlockSize: 1000,
        rowDeselection: true,
        accentedSort: true
    }
    onGridReady(params) {
        //this.gridApi.sizeColumnsToFit();
        //this.gridApi.resetRowHeights();
        this.gridApi = params.api;
        let _this = this;
        setTimeout(function () {
            params.api.setRowData(_this.getRowData());
        }, 500);
    }
    callGridReload(templateCode: string, Api: string) {
        this.getRows = [];
        // Do not use if grid will have row count well under 1000
        this.data.loadGetGridDataSP(Api, templateCode, "")
            .subscribe(
                (ret: boolean) => {
                    if (ret) {
                        if (this.data.gridData) {
                            this.lstDocData = this.data.gridData;
                            for (let i: number = 0; i < this.lstDocData.length; i++) {
                                if (this.getRows.map(function (e) { return e }).indexOf(this.lstDocData[i].docDefDataRowID) === -1) {
                                    this.getRows.push(this.lstDocData[i].docDefDataRowID)
                                }
                            }
                            
                            }
                        }

                },
                (err: any) => console.log(err),
                () => {
                    this.callGridRefresh();
                }
            );
    }
    headerHeightSetter() {
        var padding = 20;
        var height = headerHeightGetter() + padding;
        if (this.api) {
            this.api.setHeaderHeight(height);
            this.api.resetRowHeights();
        }
    }
    public callGridRefresh() {
        let _this = this;
        if (this.gridApi !== null && this.gridApi !== undefined)
            setTimeout(function () {
                _this.gridApi.setRowData(_this.getRowData());
            }, 500);
    }
}

function headerHeightGetter() {
    var columnHeaderTexts = Array.from(
        document.querySelectorAll('.ag-header-cell-text'),
    );
    var clientHeights = columnHeaderTexts.map(
        headerText => headerText.clientHeight
    );
    var tallestHeaderTextHeight = Math.max(...clientHeights);

    return tallestHeaderTextHeight;
}